import React from 'react'

import styled from 'styled-components'
import { Box, Container, Flex, Heading, Measure, Text } from 'rebass'

import { Link as Base } from 'rebass'

const Link = styled(Base)`
	font-size: 0.8rem;
	color: #001f3f;
	text-decoration: none;
	&:hover {
		color: hotpink;
	}
`

const About = () => (
	<section>
		<Container>
			<Flex
				pb={3}
				flexWrap="wrap"
				flexDirection="row"
				alignItems={['center', 'center', 'baseline']}
				justifyContent={['center', 'center', 'space-between']}
			>
				<Box mt={[5, 5, 6]} mb={[2, 2, 6]} id="about">
					<Heading
						fontSize={[3, 4, 4]}
						fontWeight={600}
						color="#001f3f"
						children="About us"
					/>
					<Measure
						mt={4}
						fontSize={[1, 2, 2]}
						lineHeight={1.7}
						color="#3f3f3f"
						maxWidth="28em"
						children="Same-origin is a remote friendly software consultancy with headquarters in Singapore. We try to be on top of what's happening in tech by continuously educating ourselves, and experimenting with the latest trends."
					/>
					<Measure
						mt={3}
						fontSize={[1, 2, 2]}
						lineHeight={1.7}
						color="#3f3f3f"
						maxWidth="28em"
						children="We specialize in MVP discovery, rapid prototyping, and full-stack concept-to-deployment development of web and mobile applications."
					/>
					<Measure
						mt={3}
						fontSize={[1, 2, 2]}
						lineHeight={1.7}
						color="#3f3f3f"
						maxWidth="28em"
						children="We are able to adapt to your needs and offer you a package that delivers flexibility, high quality results and also fits the budget you're willing to spend."
					/>
				</Box>
				<Box mt={[5, 5, 6]} mb={[5, 5, 6]}>
					<Heading
						fontSize={[3, 4, 4]}
						fontWeight={600}
						color="#001f3f"
						children="Got a project? Let's talk"
					/>
					<Measure
						mt={4}
						fontSize={[1, 2, 2]}
						lineHeight={1.7}
						color="#3f3f3f"
						maxWidth="28em"
						children="We are always looking for great new opportunities for building apps, websites or products."
					/>
					<Measure
						mt={3}
						fontSize={[1, 2, 2]}
						lineHeight={1.7}
						color="#3f3f3f"
						maxWidth="28em"
						children="If you already have an idea of what you want to do we can build on it. If not we can discuss your idea and produce a complete proposal for you. Don't worry we can hammer it out together!"
					/>
					<Flex
						flexWrap="wrap"
						flexDirection={['column', 'row', 'row']}
						alignItems="baseline"
					>
						<Measure
							mt={3}
							fontSize={[1, 2, 2]}
							lineHeight={1.7}
							color="#3f3f3f"
							maxWidth="28em"
							children="We are located at "
						/>
						<Link
							ml={[0, 2, 2]}
							href="https://goo.gl/maps/XbndCFBE2p72"
							target="_blank"
							children="138 Robinson Road, 068906, Singapore"
						/>
					</Flex>
					<Flex
						flexWrap="wrap"
						flexDirection={['column', 'row', 'row']}
						alignItems="baseline"
					>
						<Measure
							mt={3}
							fontSize={[1, 2, 2]}
							lineHeight={1.7}
							color="#3f3f3f"
							maxWidth="28em"
							children="You can get in touch with us at "
						/>
						<Link
							ml={[0, 2, 2]}
							fontSize={2}
							href="mailto:hello@sameorigin.co?subject=Ground Control I need help with.."
							children="hello@sameorigin.co"
						/>
					</Flex>
				</Box>
			</Flex>
		</Container>
	</section>
)

export default About



// WEBPACK FOOTER //
// ./src/components/about.js